import { defineStore } from 'pinia'

const useShipmentStore = defineStore('shipment', {
  state: () => ({}),
  actions: {},
})

export default useShipmentStore
